class SellingOptionsHelpers {

  isSellingApprovedVenue(venue) { //eslint-disable-line
    if (!venue) return false;

    return !!venue.isSellingApproved;
  }
}

SellingOptionsHelpers.$inject = [];

export default SellingOptionsHelpers;



// WEBPACK FOOTER //
// ./src/services/sellingOptionsHelperService.js